/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";

import "../../styling/layout-components/PracticeElective.css";
// Import các component template nội dung đầy đủ
import QPrompt1_1 from "../../templates/content/QPrompt1_1";
import QPrompt1_2 from "../../templates/content/QPrompt1_2";
import QPrompt1_3 from "../../templates/content/QPrompt1_3";
import QPrompt2_1 from "../../templates/content/QPrompt2_1";
import QPrompt2_2 from "../../templates/content/QPrompt2_2";
import QPrompt2_3 from "../../templates/content/QPrompt2_3";
import QPrompt2_4 from "../../templates/content/QPrompt2_4";
import QPrompt3_1 from "../../templates/content/QPrompt3_1";
import QPrompt3_2 from "../../templates/content/QPrompt3_2";
// Import các component template câu hỏi đầy đủ
import DragDrop from "../../templates/calibration/DragDrop";
import DragDropMulti from "../../templates/calibration/DragDropMulti";
import Gapfill from "../../templates/calibration/Gapfill";
import MultipleChoice from "../../templates/calibration/MultipleChoice";
import MultipleResponse from "../../templates/calibration/MultipleResponse";
import VerticalGapfill from "../../templates/calibration/VerticalGapfill";
import VerticalMultipleChoice from "../../templates/calibration/VerticalMultipleChoice";
import VerticalMultipleResponse from "../../templates/calibration/VerticalMultipleResponse";
import ProgressBar from "../../layout-components/filter-question/practice-smart/PracticeSmartNav";
function CalibrationContent({
  question,
  seenQuestions,
  submitAnswers,
  showEndCalibration,
  playingAudioRef,
  handleNextQuestion,
  // progress, // Thêm prop progress để hiển thị tiến độ
}) {
  const [nextScroll, setNextScroll] = useState(false);
  const [isPracticeCompleted, setIsPracticeCompleted] = useState(false);

  const status = useSelector((state) => state.calibration.status);

  const backgroundStyle = {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    boxShadow: "2px 4px 0px 0px #0a2a66",
    borderRadius: "1rem",
    border: "1.5px solid #0a2a66",
  };

  useEffect(() => {
    if (isPracticeCompleted) {
      const timer = setTimeout(() => {
        setIsPracticeCompleted(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isPracticeCompleted]);

  const handleSkip = () => {
    handleNextQuestion();
  };

  const TemplateComponent = () => {
    if (!question?.template?.prompt) return <div>Không có prompt template.</div>;
    const commonProps = {
      data: question,
      isLast: true,
      order: question.questionIndex + 1,
      playingAudioRef: playingAudioRef,
    };
    switch (question.template.prompt) {
      case "QPrompt1_1": return <QPrompt1_1 {...commonProps} />;
      case "QPrompt1_2": return <QPrompt1_2 {...commonProps} />;
      case "QPrompt1_3": return <QPrompt1_3 {...commonProps} />;
      case "QPrompt2_1": return <QPrompt2_1 {...commonProps} />;
      case "QPrompt2_2": return <QPrompt2_2 {...commonProps} />;
      case "QPrompt2_3": return <QPrompt2_3 {...commonProps} />;
      case "QPrompt2_4": return <QPrompt2_4 {...commonProps} />;
      case "QPrompt3_1": return <QPrompt3_1 {...commonProps} />;
      case "QPrompt3_2": return <QPrompt3_2 data={question} order={question.questionIndex + 1} playingAudioRef={playingAudioRef} />;
      default: return <div>Template không tìm thấy</div>;
    }
  };

  const TemplateQuestion = () => {
    if (!question?.template?.question) return null;
    const props = {
      question: question?.question,
      explanation: question?.explanation,
      backgroundImage: question?.question?.backgroundImage,
      questionIndex: question.questionIndex,
      isLast: question.questionIndex === 14,
      nextQuestion: handleNextQuestion,
      setNextScroll,
      showEndCalibration: showEndCalibration,
      submitAnswers: submitAnswers,
      seenQuestions: seenQuestions,
      playingAudioRef: playingAudioRef,
    };
    const verticalProps = {
      ...props,
      backgroundImage: [
        question?.prompt?.backgroundImage,
        question?.question?.backgroundImage,
      ],
    };

    switch (question.template.question) {
      case "MultipleChoice":
        return <MultipleChoice {...props} />;
      case "VerticalMultipleChoice":
        return <VerticalMultipleChoice {...verticalProps} />;
      case "VerticalMultipleResponse":
        return <VerticalMultipleResponse {...verticalProps} />;
      case "VerticalGapfill":
        return <VerticalGapfill {...verticalProps} />;
      case "MultipleResponse":
        return <MultipleResponse {...props} />;
      case "Gapfill":
        return <Gapfill {...props} />;
      case "DragDrop":
        return <DragDrop {...props} />;
      case "DragDropMulti":
        return <DragDropMulti {...props} />;
      default:
        return null;
    }
  };

  if (status === "loading" && !question) {
    return <div>Đang tải câu hỏi...</div>;
  }

  if (status === "failed") {
    return <div>Lỗi khi tải câu hỏi. Vui lòng thử lại sau.</div>;
  }

  if (!question) {
    return <div>Không có câu hỏi nào để hiển thị.</div>;
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", flexDirection: "column" }}>
      {/* <ProgressBar progress={progress} />
      <div style={{ marginBottom: "1rem", width: "80%", maxWidth: 800 }}>
        <div style={{ height: 20, backgroundColor: "#e0e0e0", borderRadius: 10, overflow: "hidden" }}>
          <div
            style={{
              width: `${(progress * 100).toFixed(0)}%`,
              height: "100%",
              backgroundColor: "#0a2a66",
              transition: "width 0.3s ease-in-out",
            }}
          />
        </div>
        <div style={{ textAlign: "right", fontWeight: "600", marginTop: 4 }}>
          {`${(progress * 100).toFixed(0)}% hoàn thành`}
        </div>
      </div> */}

      <BackgroundImageFromUrl
        objectId={question?.backgroundImage}
        className="is-centered"
        style={{ ...backgroundStyle, width: "60rem" }}
      >
        <div className="">
          <TemplateComponent />
        </div>
        <div className="">
          <TemplateQuestion />
        </div>
      </BackgroundImageFromUrl>
    </div>
  );
}

export default CalibrationContent;
